import { render, staticRenderFns } from "./MallForm.vue?vue&type=template&id=6d551bac&scoped=true&"
import script from "./MallForm.vue?vue&type=script&lang=ts&"
export * from "./MallForm.vue?vue&type=script&lang=ts&"
import style0 from "./MallForm.vue?vue&type=style&index=0&id=6d551bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d551bac",
  null
  
)

export default component.exports